import { HorizontalCardColorVariants } from "./types";

export const colorScheme: Record<
  HorizontalCardColorVariants,
  { titleClass: string; descriptionClass: string; rootClass: string }
> = {
  [HorizontalCardColorVariants.Default]: {
    titleClass: "font-medium text-dark",
    descriptionClass: "text-dark",
    rootClass: "bg-neutral",
  },
  [HorizontalCardColorVariants.PrimaryTitle]: {
    titleClass: "text-primary font-normal",
    descriptionClass: "text-dark",
    rootClass: "bg-neutral",
  },
  [HorizontalCardColorVariants.PrimaryBackground]: {
    titleClass: "font-medium text-light",
    descriptionClass: "text-light",
    rootClass: "bg-primary",
  },
};
